let userCountry = "in";

try {
    // Get the user's locale (e.g., 'en-US', 'en-GB', 'hi-IN')
    const locale = navigator.language || navigator.userLanguage;

    // Extract country code from locale (last 2 characters)
    if (locale && locale.includes("-")) {
        userCountry = locale.split("-")[1].toLowerCase();
    }
} catch (error) {
    console.log(
        "Could not detect country from locale, using default (India)"
    );
}

export { userCountry };
